import $ from 'jquery';
import Isotope from 'isotope-layout';

$(document).ready(function() {
    $('.portfolioIsotopeListing').each(function (index, element) {
        const listingSelector = '.listing';
        const listSelector = listingSelector + '__list';
        const itemSelector = listingSelector + '__item';
        const $listing = $(element);
        const $filters = $listing.find(listingSelector + '__filters');
        const $filterDropdown = $filters.find('select');
        const $filterButtons = $filters.find('a');
        const $items = $listing.find(itemSelector);
        const $pagination = $listing.find(listingSelector + '__pagination');
        const step = 6;
        let visibleItemsNum = step;
        let filterValue = '*';
        let matchCounter = 0;
        let uri = location.href;

        function resetItemsHeight() {
            $items.css('height', '');
            $items.each(function (index, element) {
                const $item = $(element);
                $item.css('height', $item.outerHeight());
            });
        }

        function showMoreItems() {
            visibleItemsNum = visibleItemsNum + step;
            matchCounter = 0;
            isotope.arrange();
            $pagination.toggle( matchCounter > visibleItemsNum );
        }

        function applyIsotopeFilter() {
            resetItemsHeight();
            matchCounter = 0;
            isotope.arrange();
            $pagination.toggle( matchCounter > visibleItemsNum );
            $filterButtons.removeClass('active');
            $filterButtons.filter('[href="'+uri+'"]').addClass('active');
            $filterDropdown.find('option[value="'+uri+'"]').prop('selected', 'selected').trigger('change');
        }

        function alignItemsHeight() {
            let itemsInRow = [];
            let rowHeight = 0;
            const filteredElements = isotope.getFilteredItemElements();
            resetItemsHeight();
            filteredElements.forEach(function (element, index) {
                const $item = $(element);
                if ( index > 0 ) {
                    if ( $item.offset().top === $(filteredElements[index-1]).offset().top ) {
                        itemsInRow.push( $item );
                        rowHeight = $item.outerHeight() > rowHeight ? $item.outerHeight() : rowHeight;
                    }
                    else {
                        itemsInRow.forEach(function ($item) {
                            $item.css('height', rowHeight);
                        });
                        itemsInRow = [ $item ];
                        rowHeight = $item.outerHeight();
                    }
                } else {
                    itemsInRow.push( $item );
                    rowHeight = $item.outerHeight();
                }
                if ( index === filteredElements.length - 1 ) {
                    itemsInRow.forEach(function ($item) {
                        $item.css('height', rowHeight);
                    });
                }
            });
        }

        function isotopeFilter() {
            const match = filterValue === '*' || $(this).hasClass( filterValue );
            if ( match ) {
                matchCounter++;
            }
            return match && matchCounter <= visibleItemsNum;
        }

        function handleFilters() {
            const hashValue = location.hash.substring(1);
            filterValue = hashValue;
            uri = location.href;
            if (hashValue === 'all' || hashValue === '') {
                filterValue = '*';
            }
            if (hashValue === '') {
                uri = location.href + '#all';
            }
            applyIsotopeFilter();
        }

        const isotope = new Isotope(listSelector, {
            itemSelector: itemSelector,
            layoutMode: 'fitRows',
            filter: isotopeFilter
        });

        alignItemsHeight();
        handleFilters();
        $(window).on('hashchange', handleFilters);
        isotope.on('layoutComplete', alignItemsHeight);
        $pagination.on('click', 'button', showMoreItems);
    });
});